module.exports = __webpack_public_path__ + "img/right-bg.a0961d29.png";